import EcoSectionCard from 'eco-design/sections/eco-section-card';
import styles from './index.module.scss';
import { useLang } from '@/i18n';

export default function Comp() {
    const { t } = useLang('dp3.page_v2.SectionB');

    return (
        <div className={styles.comp} id="SectionB">
            <EcoSectionCard
                theme="black"
                layout="center-center"
                title={t('title')}
                pc="https://websiteoss.ecoflow.com/upload/image/1745459076750/B.jpg"
                h5="https://websiteoss.ecoflow.com/upload/image/1745459075818/B-h5.jpg"
            />
        </div>
    );
}
